import React from "react";
import { theme } from "../../utils/theme";
import { Flex, Text } from "rebass";
import { getLocalizedString } from "../../utils";

function Avatar({ name, size = 32, isPage = false, nameSize, ...otherProps }) {
  // small hack as for some reason sometime there's a null string. Yoda ?
  name = name && name.replace("null", "").trim();

  const getColorAvatar = (name) => {
    if (name) {
      const colors = [
        "#1abc9c",
        "#16a085",
        "#f1c40f",
        "#f39c12",
        "#2ecc71",
        "#27ae60",
        "#e67e22",
        "#d35400",
        "#3498db",
        "#2980b9",
        "#e74c3c",
        "#c0392b",
        "#9b59b6",
        "#8e44ad",
        "#bdc3c7",
        "#34495e",
        "#2c3e50",
        "#95a5a6",
        "#7f8c8d",
        "#ec87bf",
        "#d870ad",
        "#f69785",
        "#9ba37e",
        "#b49255",
        "#b49255",
        "#a94136",
        "#55efc4",
        "#81ecec",
        "#74b9ff",
        "#a29bfe",
        "#dfe6e9",
        "#00b894",
        "#00cec9",
        "#0984e3",
        "#6c5ce7",
        "#b2bec3",
        "#ffeaa7",
        "#fab1a0",
        "#ff7675",
        "#fd79a8",
        "#636e72",
        "#fdcb6e",
        "#e17055",
        "#d63031",
        "#e84393",
        "#2d3436",
      ];

      var c = name.match(/\b\w/g).join("").substr(0, 2).toUpperCase();
      var colorIndex;
      if (c.length > 1)
        colorIndex = Math.floor(
          Math.abs(c.charCodeAt(0) + c.charCodeAt(1) - 130) % colors.length,
        );
      else
        colorIndex = Math.floor(Math.abs(c.charCodeAt(0) - 65) % colors.length);
      return colors[colorIndex];
    } else {
      return "#000";
    }
  };

  return (
    <Flex {...otherProps}>
      <Flex
        width={size}
        height={size}
        alignItems="center"
        justifyContent="center"
        title={name}
      >
        <svg
          style={{
            background: getColorAvatar(name),
            height: size + "px",
            width: size + "px",
            minWidth: size + "px",
            minHeight: size + "px",
            borderRadius: "100px",
          }}
        >
          <rect
            fill={getColorAvatar(name)}
            x="0"
            y="0"
            style={{
              height: size + "px",
              width: size + "px",
              minWidth: size + "px",
              minHeight: size + "px",
              borderRadius: "100px",
            }}
          ></rect>
          <text
            alt={name}
            fill={theme.white}
            fontSize={isPage ? "size / 2" : size / 3}
            textAnchor="middle"
            x={size / 2}
            y={size / 2 + size / (isPage ? 6 : 8)}
            title={name}
          >
            {name && name.match(/\b\w/g).join("").substr(0, 2).toUpperCase()}
          </text>
        </svg>
      </Flex>
      {isPage && (
        <Flex
          alignItems="center"
          sx={{
            fontSize: "1.5em",
            color: "#232323",
            marginLeft: "1em",
            textTransform: "uppercase",
          }}
        >
          <span style={{ fontSize: nameSize ? nameSize : null }}>{name}</span>
        </Flex>
      )}
    </Flex>
  );
}

export { Avatar };
